export const canImportFileContent = (type?: string): boolean => type !== 'attachment';
